import { render, staticRenderFns } from "./PcPcmRegnTap1.vue?vue&type=template&id=5eb09ca5&"
import script from "./PcPcmRegnTap1.vue?vue&type=script&lang=js&"
export * from "./PcPcmRegnTap1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports